import PropTypes from "prop-types";
import React from "react";

const Image = ({ image, className }) => (
  <img src={image} className={className} />
);

Image.propTypes = {
  image: PropTypes.string,
  className: PropTypes.string
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.jsx